import { IReportElement } from "@monorepo/reports/src/views/EndStoragePeriodEad/types/reportElement";

export const convertApiItemToUi = (item: IReportElement): IReportElement => ({
  ...item,
  storagePeriod: item.years,
});
